import { useCallback } from "react";

import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";
import { useLibrary } from "../../../providers";

import { API } from "./api";

import type { WebDocument } from "./types";

export const useCreateShareDocuments = () => {
  const l10n = useLibrary("translations");
  const { send, loading } = useRequestWithFeedback<{
    detail: string;
  }>();

  const createShareDocuments = useCallback(
    (
      documents: WebDocument[],
      onSuccess?: () => void,
      overrideRunProps?: OverrideRunProps<{ detail: string }>,
    ) => {
      send({
        action: API.createShareDocuments(documents),
        onSuccess,
        messaging: {
          toast: {
            success: l10n.getString(
              "document-share-success",
              null,
              "Documents shared successfully",
            ),
            error: l10n.getString(
              "document-share-failure",
              null,
              "Failed to share documents. Please try again later.",
            ),
          },
        },
        ...overrideRunProps,
      });
    },
    [send, l10n],
  );

  return { createShareDocuments, loading };
};
